import React, { useEffect, useState } from "react";
import { useDeleteEntityMutation } from "../../../../../../services/RTKQuery/entities";

export const DeleteTest = ({ entityUuid, setStatusInParent }) => {
  const statusUnknown = "❓Unknown Status";
  const statusPass = "✅ Pass";
  const statusFail = "❌ Fail";

  const [statusReadSingle, setStatus] = useState(statusUnknown);
  const [detailsText, setDetailsText] = useState("statusUnknown");

  const [deleteEntitytTrigger] = useDeleteEntityMutation();
  useEffect(() => {
    deleteEntitytTrigger(entityUuid)
      .unwrap()
      .then(fulfilled => {
        if (fulfilled?.data?.ok === true) {
          setStatus(statusPass);
          setDetailsText(`: Hard deleted item: ${entityUuid}`);
          setStatusInParent("Pass");
        } else {
          console.error("delete fulfilled: ", fulfilled);
          setStatus(statusFail);
          setDetailsText(`: Did NOT delete item: ${entityUuid}`);
          setStatusInParent("Fail");
        }
      })
      .catch(error => {
        console.error("Fail: useDeleteEntityMutation", error);
        setStatus(statusFail);
        setStatusInParent("Fail");
      });
  }, [deleteEntitytTrigger, entityUuid, setStatusInParent]);

  return (
    <>
      <b>{statusReadSingle}</b>
      <small>{detailsText}</small>
    </>
  );
};
